import React, { useState } from "react";
import { Fab, Box, Chip, Menu, MenuItem } from "@mui/material";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import CryptoJS from "crypto-js";

const formatDocument = (doc) => {
  if (!doc) return "";
  const numbers = doc.replace(/\D/g, "");
  if (numbers.length === 11) {
    return numbers.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
  } else if (numbers.length === 14) {
    return numbers.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      "$1.$2.$3/$4-$5"
    );
  }
  return doc;
};

const FloatingImpersonateButton = ({ onClick }) => {
  const isImpersonating = localStorage.getItem("is_impersonating") === "true";

  let user = localStorage.getItem("user");
  user = CryptoJS.AES.decrypt(user, "MedSys@341");
  user = CryptoJS.enc.Utf8.stringify(user);

  const clientDocument = user || "";
  const [anchorEl, setAnchorEl] = useState(null);

  if (!isImpersonating) {
    return null;
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSwitchClient = () => {
    handleClose();
    onClick();
  };

  const handleReturnToMedSystems = () => {
    handleClose();
    const medsystemsCNPJ = "05273422000154";
    const encryptedCNPJ = CryptoJS.AES.encrypt(
      medsystemsCNPJ,
      "MedSys@341"
    ).toString();
    localStorage.setItem("user", encryptedCNPJ);
    localStorage.removeItem("is_impersonating");
    localStorage.removeItem("impersonated_client_document");
    window.location.reload();
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: 2,
      }}
    >
      <Chip
        label={`Acessando como ${formatDocument(clientDocument)}`}
        color="primary"
        variant="outlined"
        sx={{
          backgroundColor: "white",
          boxShadow: 1,
          display: {
            xs: "none",
            sm: "flex",
          },
        }}
      />
      <Fab color="primary" onClick={handleClick} aria-label="switch-client">
        <SupervisorAccountIcon />
      </Fab>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={handleSwitchClient}>Trocar Cliente</MenuItem>
        <MenuItem onClick={handleReturnToMedSystems}>
          Voltar a ver como MedSystems
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default FloatingImpersonateButton;
